import { datadogRum } from '@datadog/browser-rum';

export async function initializeDatadog() {
    if (!datadogRum.getInternalContext()) {
        datadogRum.init(
            {
                applicationId: process.env.VUE_APP_DATADOG_APPLICATION_ID ?? '',
                clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN ?? '',
                site: process.env.VUE_APP_DATADOG_SITE ?? '',
                service: process.env.VUE_APP_DATADOG_SERVICE ?? '',
                env: process.env.NODE_ENV,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 0,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask'
            }
        );
    }
}

export function setDatadogCorrelationId(correlationId: string | undefined) {
    datadogRum.setGlobalContextProperty('correlationId', correlationId);
}
